module.exports = __webpack_public_path__ + "img/group.9a563110.png";